import type { DashboardSearchResult } from './DashboardSearchResult'

interface DashboardSearchGroup {
  category: string
  items: DashboardSearchResult[]
}

/** Group flat API rows by `category` (or subtitle) while preserving order. */
export function groupDashboardSearchResults(rows: DashboardSearchResult[]): DashboardSearchGroup[] {
  const out: DashboardSearchGroup[] = []
  for (const row of rows) {
    const cat =
      (typeof row.category === 'string' && row.category.trim()) ||
      (typeof row.subtitle === 'string' && row.subtitle.trim()) ||
      'Results'
    const last = out[out.length - 1]
    if (last?.category === cat) {
      last.items.push(row)
    } else {
      out.push({ category: cat, items: [row] })
    }
  }
  return out
}
